if (!customElements.get('select-a-model')) {
  class SelectAModel extends HTMLElement {
    connectedCallback() {
      this.items = this.querySelectorAll('.select-a-model__item--has-hover');
      this.items.forEach((item) => {
        const video = item.querySelector('.select-a-model__video');
        if (!video) return;

        const play = () => {
          video.currentTime = 0;
          video.play().catch(() => {});
        };
        const pause = () => {
          video.pause();
          video.currentTime = 0;
        };

        item.addEventListener('mouseenter', play);
        item.addEventListener('mouseleave', pause);
        item.addEventListener('focusin', play);
        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) pause();
        });
      });
    }
  }

  customElements.define('select-a-model', SelectAModel);
}
